module.exports = __webpack_public_path__ + "img/MetallbauEFZ-CR-3972-quer.967c193d.jpg";